import { useState } from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import KardexEstudiante from "./componentes/kardexEstudiante";

const Kardex = () => {
  const [busqueda, setBusqueda] = useState("");
  const [estudiantes, setEstudiantes] = useState([]);
  const [estudianteSeleccionado, setEstudianteSeleccionado] = useState(null);
  const [loadingBusqueda, setLoadingBusqueda] = useState(false);

  const buscarEstudiantes = async (texto) => {
    setBusqueda(texto);

    if (texto.trim().length < 2) {
      setEstudiantes([]);
      return;
    }

    setLoadingBusqueda(true);

    try {
      const token = sessionStorage.getItem("access_token");

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/estudiante/${encodeURIComponent(
          texto.trim()
        )}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();

      console.log("Estudiantes encontrados:", data);

      if (res.ok) {
        setEstudiantes(Array.isArray(data) ? data : []);
      } else {
        setEstudiantes([]);
      }
    } catch (error) {
      console.error("Error buscando estudiantes:", error);
      setEstudiantes([]);
    } finally {
      setLoadingBusqueda(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>

              {/* CABECERA */}
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  background: "linear-gradient(45deg, #e60000, #ff3300)",
                  color: "white",
                }}
              >
                <MDTypography variant="h6" color="white">
                  Kardex Académico
                </MDTypography>
              </MDBox>

              {/* BUSCADOR */}
              <MDBox p={3}>
                <MDTypography variant="h6" mb={2}>
                  Buscar estudiante
                </MDTypography>

                <Autocomplete
                  options={estudiantes}
                  value={estudianteSeleccionado}
                  inputValue={busqueda}
                  loading={loadingBusqueda}
                  onInputChange={(event, value) => {
                    buscarEstudiantes(value);
                  }}
                  onChange={(event, value) => {
                    setEstudianteSeleccionado(value);
                  }}
                  getOptionLabel={(option) =>
                    `${option.name || ""} ${
                      option.apellido_paterno || ""
                    } ${option.apellido_materno || ""} ${
                      option.codigo ? `- ${option.codigo}` : ""
                    }`.trim()
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  noOptionsText={
                    busqueda.length < 2
                      ? "Escribe al menos 2 caracteres"
                      : "No se encontraron estudiantes"
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Buscar estudiante"
                      placeholder="Nombre, apellido, CI o código"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingBusqueda && (
                              <CircularProgress
                                color="inherit"
                                size={20}
                              />
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </MDBox>

              {/* KARDEX DEL ESTUDIANTE */}
              {estudianteSeleccionado && (
                <MDBox px={3} pb={3}>
                  <KardexEstudiante
                    estudianteId={estudianteSeleccionado.usuario_id}
                  />
                </MDBox>
              )}

            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
};

export default Kardex;